import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {loadLetter, loadLettersByStack, loadStack, downloadLetter} from "../../store/app/app.slice";
import {Spin, Card, Button, Space, Row, Col} from "antd";
import StackLetter from "./StackLetter";
import {LeftCircleOutlined, DownloadOutlined} from "@ant-design/icons";
import {getProcessedLetterStatusColor, getProcessedLetterStatusLabel} from "../helper/labelHelper";
import {getAuthenticatedUser} from "../../utils/authHelper";

export default function LetterDetail(props) {
    const dispatch = useDispatch();
    const params = useParams();
    const {currentLetter} = useSelector((state) => state.app);
    const amjUser = getAuthenticatedUser();
    
    useEffect(() => {
        dispatch(loadLetter({finalData: {id: params?.letterId}}))
    }, []);

    const handleDownload = () => {
        dispatch(downloadLetter({
            finalData: {id: params?.letterId},
            callbackSuccess: (response) => {
                const contentDisposition = response.headers["content-disposition"];
                const filename = contentDisposition ? contentDisposition.split("=")[1] : `letter-${params?.letterId}.docx`;
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }));
    };
    
    return <>
        { (currentLetter && ""+currentLetter.id === params.letterId) ? 
        <>
                <Row>
                    <Col span={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title={<Space>
                                <span>Letter-Details: Ref.:{currentLetter.originalLetter?.letterId || currentLetter.id}</span>
                                <Button type="text" style={{backgroundColor: getProcessedLetterStatusColor(currentLetter), color: 'white'}}>
                                    {getProcessedLetterStatusLabel(currentLetter)}
                                </Button>
                                    <Button type="primary" icon={<DownloadOutlined />} onClick={handleDownload}>
                                        Download
                                    </Button>
                            </Space>}
                            extra={<Button className={"ant-tag-close-icon"} type="default" onClick={() => {window.history.back()}}>
                                <LeftCircleOutlined/>Back
                            </Button>}
                        >
                        </Card>
                    </Col>
                </Row>
                <Row style={{height: "80%"}}>
                    <Col span={24} style={{height: "100%"}} >
                        <StackLetter key={params.letterId} letter={currentLetter} stack={null} /> 
                    </Col>
                </Row>
            </>

        : <Spin tip="Loading..."></Spin>}
    </>
}